import React, { useState } from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  width: 30%;
  max-width: 300px;
  /* border: 1px solid #80cc2a; */
  /* border-radius: 8px; */
  /* box-shadow: 0 4px 8px rgba(128, 204, 42, 0.2); */
  padding: 10px;
  /* margin: 7px; */
  margin-right: 8%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

`;



const Icon = styled.img`
  width: 80px;
  height: 80px;
  padding-top: 2%;
  /* background-color: #7cc529; */
  /* border-radius: 50%; */
  /* margin-bottom: 10px; */
`;

const Title = styled.h3`
  font-size: 1.4rem;
  /* margin-bottom: 10px; */
  width:300px;
  height: 50px;
  margin-top: 10px;
  /* border: 1px solid red; */
`;

const Description = styled.p`
  font-size: 1.2rem;
  /* margin-bottom: 10px; */
  /* border: 1px solid red; */
  width: 300px;
  height: 50px;
  margin-top: 0px;
`;

const Button = styled.button`
  background-color: #80cc2a;
  color: #fff;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 150px;
  height: 50px;
  /* border: 1px solid red; */
  /* font-size: 1.2; */
`;

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid red;
`;

const PopupContent = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 70%;
`;

const PopupHeader = styled.h2`
  color: #1d2c42; /* Change header color */
`;

const PopupText = styled.p`
  font-size: 16px;
  line-height: 1.6;
`;

const Card = ({ icon, title, description, moreInfoTitle, moreInfoText }) => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <CardContainer>
 
      <Icon src={icon} />
 
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Button onClick={togglePopup}>Learn More</Button>
      {showPopup && (
        <PopupOverlay>
          <PopupContent>
            <PopupHeader>{moreInfoTitle}</PopupHeader> {/* Use PopupHeader component */}
            <PopupText>{moreInfoText}</PopupText>
            <Button onClick={togglePopup}>Close</Button>
          </PopupContent>
        </PopupOverlay>
      )}
    </CardContainer>
  );
};

export default Card;
